import React from 'react';
import WithFooter from '../layout/WithFooter';
import WithBackButton from '../layout/WithBackButton';

export default function() {
    return (
        <WithFooter>
            <WithBackButton>
                <h4>Поддержка пользователей:</h4>
                <React.Fragment>
                    Если у вас возникли вопросы или проблемы, связанные с покупкой билетов,
                    напишите письмо на адрес <a href="mailto:ticket@kudago.com">ticket@kudago.com</a>.
                    В письме опишите вашу проблему и обязательно укажите email, который вы вводили при покупке билетов, и как вас зовут.
                    <br />
                    <br />

                    Также вы можете позвонить по телефону <a href="tel:+79990350485">+79990350485</a>.
                    <br />
                </React.Fragment>
            </WithBackButton>
        </WithFooter>
    );
}
